const green = '#9BC23C';
const magenta = '#E0107D';
const blue = '#1F9BD5';
const black = '#000000';
const brokenBlack = '#171717';
const white = '#FFF';
const brokenWhite = '#f0f0f0';
const grey = '#4E4E4E';
const darkGrey = 'rgb(35, 35, 35)';
const bordergrey = '#D9D9D9';
const borderHero = '#fafafa4d';
const overlaySlideshow = '#00000090';
const overlayGallery = '#000000d9';
const overlayProjectGrid = '#0000002a';
const overlayProject = 'rgba(0, 0, 0, 0.05)';
const theme = {
  common: {
    black,
    white,
    brokenWhite,
    brokenBlack,
    grey,
    darkGrey,
    bordergrey,
    borderHero,
    overlaySlideshow,
    overlayProjectGrid,
    overlayGallery,
    overlayProject,
    blue,
    green,
    magenta,
  },
};

// For an element nested inside an alternating white/brokenWhite section: the opposite
// shade, so it stands out against its own section background instead of blending in.
export const oppositeShade = (bg) => (bg === white ? brokenWhite : white);

export default theme;
